import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles/createTheme";

export const useStyles = makeStyles<Theme>((theme) => ({
  wrapper: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  text: {
    color: "inherit",
    display: "block",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    cursor: "pointer",
    textDecoration: "underline",

    "&:hover": {
      color: theme.palette.primary.main,
    },
  },
  previewButton: {
    padding: "4px",
    opacity: 0,
    "tr:hover &": {
      opacity: 1,
    },
    "@media (max-width: 767px)": {
      opacity: 1,
    },
  },
  menu: {
    fontSize: "0",
    padding: "16px 24px",
  },
}));
